export enum AccountType {
  standard = 'STANDARD',
  twitter = 'TWITTER',
  google = 'GOOGLE',
  facebook = 'FACEBOOK',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/account-type.ts